import { Component, Input } from '@angular/core';
import { IDataCardAmountComponent } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-card-amount',
	templateUrl: './card-amount.component.html',
	styleUrls: ['./card-amount.component.scss']
})
export class CardAmountComponent {
	lisColor = [
		{
			name: 'yellow',
			color: '#ffbf5a'
		},
		{
			name: 'light-blue',
			color: '#26d1f1'
		},
		{
			name: 'lilac',
			color: '#7599fc'
		}
	];
	@Input() items: IDataCardAmountComponent[] = [];
	@Input() isCardPayment = false;
	@Input() color?: 'yellow' | 'light-blue' | 'lilac' = 'yellow';

	getColor(): string {
		const colorResult = this.lisColor.find((item) => item.name === this.color);
		return colorResult ? colorResult.color : 'yellow';
	}
}
